<template>
  <div class="login-page">
    <!-- 左侧品牌展示区 -->
    <div class="brand-panel">
      <!-- 装饰元素 -->
      <div class="deco-grid"></div>
      <div class="deco-ring deco-ring-1"></div>
      <div class="deco-ring deco-ring-2"></div>
      <div class="deco-glow"></div>

      <div class="brand-content">
        <div class="brand-logo">
          <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
            <defs>
              <linearGradient id="login-logo-grad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stop-color="#6AA5FF"/>
                <stop offset="1" stop-color="#165DFF"/>
              </linearGradient>
            </defs>
            <path d="M24 2.5 L43 9.5 V22 C43 33.2 34.8 41.6 24 45.5 C13.2 41.6 5 33.2 5 22 V9.5 Z" fill="url(#login-logo-grad)"/>
            <circle cx="24" cy="22" r="9.5" fill="none" stroke="#fff" stroke-width="2.6" opacity="0.95"/>
            <circle cx="24" cy="22" r="3.6" fill="#fff"/>
            <path d="M24 22 L33.5 31.5" stroke="#fff" stroke-width="2.8" stroke-linecap="round"/>
          </svg>
        </div>
        <h1 class="brand-name">哨兵安全监控</h1>
        <p class="brand-slogan">工业车辆主动安全 · 智能监管平台</p>

        <ul class="feature-list">
          <li v-for="f in features" :key="f.title" class="feature-item">
            <span class="feature-icon"><i :class="f.icon"></i></span>
            <div class="feature-text">
              <div class="feature-title">{{ f.title }}</div>
              <div class="feature-desc">{{ f.desc }}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 右侧登录表单区 -->
    <div class="form-panel">
      <div class="form-box">
        <div class="form-head">
          <h2 class="form-title">欢迎回来</h2>
          <p class="form-sub">请使用您的账号登录管理平台</p>
        </div>

        <el-form
          :model="loginForm"
          :rules="loginRules"
          ref="loginFormRef"
          class="password-login-form"
          size="medium"
        >
          <!-- 手机号码 -->
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="请输入手机号码"
              prefix-icon="el-icon-mobile-phone"
              maxlength="11"
            ></el-input>
          </el-form-item>

          <!-- 密码 -->
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              type="password"
              show-password
            ></el-input>
          </el-form-item>

          <!-- 记住密码 -->
          <div class="login-options">
            <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
          </div>

          <!-- 登录按钮 -->
          <el-form-item>
            <el-button
              type="primary"
              @click="handlePasswordLogin"
              round
              class="login-button"
              :loading="logging"
            >
              登 录
            </el-button>
          </el-form-item>
        </el-form>

        <div class="login-footer">
          <p>© 2026 哨兵安全监控管理系统 · 版权所有</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      logging: false,
      // 品牌区功能亮点
      features: [
        { icon: 'el-icon-location', title: '实时监控', desc: '设备状态与位置一目了然' },
        { icon: 'el-icon-warning', title: '智能告警', desc: '异常事件即时推送处理' },
        { icon: 'el-icon-s-check', title: '安全管理', desc: '限速区域精细管控' },
        { icon: 'el-icon-position', title: '轨迹回溯', desc: '运营数据完整留痕' }
      ],
      // 登录表单
      loginForm: {
        username: '',
        password: ''
      },
      // 登录规则
      loginRules: {
        username: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$|^admin$/, message: '请输入正确的手机号码或admin', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      },
      // 记住密码
      rememberPassword: false
    }
  },
  methods: {
    // 处理密码登录
    handlePasswordLogin() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          this.logging = true
          this.$store.dispatch('login', this.loginForm).then(() => {
            this.logging = false
            this.$message.success('登录成功')
            this.$router.push('/home')
          }).catch((error) => {
            this.logging = false
            this.$message.error('登录失败：' + (error.message || '请检查您的登录信息'))
          })
        } else {
          this.$message.error('请填写正确的登录信息')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;
}

/* ============ 左侧品牌区 ============ */
.brand-panel {
  position: relative;
  flex: 1.2;
  background: linear-gradient(150deg, #16294E 0%, #1C2A4A 35%, #0E1B36 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 60px;
}

/* 网格装饰 */
.deco-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: radial-gradient(ellipse at 30% 40%, rgba(0,0,0,0.9), transparent 75%);
}

/* 装饰圆环 */
.deco-ring {
  position: absolute;
  border-radius: 50%;
  border: 1.5px solid rgba(64, 128, 255, 0.28);
}

.deco-ring-1 {
  width: 480px;
  height: 480px;
  right: -160px;
  top: -120px;
}

.deco-ring-2 {
  width: 320px;
  height: 320px;
  right: -60px;
  top: -40px;
  border-color: rgba(64, 128, 255, 0.18);
}

/* 光斑 */
.deco-glow {
  position: absolute;
  width: 500px;
  height: 500px;
  left: -180px;
  bottom: -200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(22, 93, 255, 0.35) 0%, transparent 65%);
}

.brand-content {
  position: relative;
  z-index: 2;
  max-width: 440px;
}

.brand-logo {
  margin-bottom: 24px;
}

.brand-logo svg {
  filter: drop-shadow(0 4px 12px rgba(22, 93, 255, 0.55));
}

.brand-name {
  font-size: 34px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 3px;
  margin: 0 0 10px;
}

.brand-slogan {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 1px;
  margin: 0 0 48px;
}

/* 功能亮点列表 */
.feature-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 14px;
}

.feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(22, 93, 255, 0.22);
  border: 1px solid rgba(64, 128, 255, 0.35);
  color: #6AA5FF;
  font-size: 18px;
  flex-shrink: 0;
}

.feature-title {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 3px;
}

.feature-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

/* ============ 右侧表单区 ============ */
.form-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 40px;
}

.form-box {
  width: 100%;
  max-width: 380px;
}

.form-head {
  margin-bottom: 36px;
}

.form-title {
  font-size: 26px;
  font-weight: 700;
  color: #1D2129;
  margin: 0 0 10px;
}

.form-sub {
  font-size: 14px;
  color: #86909C;
  margin: 0;
}

/* 登录表单 */
.password-login-form {
  width: 100%;
}

.password-login-form .el-input__inner {
  height: 46px;
  line-height: 46px;
}

.login-options {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 24px;
  font-size: 14px;
}

/* 登录按钮 */
.login-button {
  width: 100%;
  height: 46px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 6px;
  background: linear-gradient(90deg, #4080FF 0%, #165DFF 100%);
  border: none;
  color: #fff;
  box-shadow: 0 6px 16px rgba(22, 93, 255, 0.35);
  transition: all 0.25s ease;
}

.login-button:hover,
.login-button:focus {
  background: linear-gradient(90deg, #4E93FF 0%, #2A6DFF 100%);
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(22, 93, 255, 0.4);
}

/* 底部版权 */
.login-footer {
  margin-top: 40px;
  text-align: center;
  font-size: 12px;
  color: #C0C4CC;
}

/* 响应式 */
@media (max-width: 900px) {
  .brand-panel {
    display: none;
  }
  .form-panel {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .form-panel {
    padding: 24px;
  }
  .form-title {
    font-size: 22px;
  }
}
</style>
